import { useState, useEffect } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
    capitalizeFirstLetter,
    getStatusDiscountTextColor,
    getStatusColorDiscount,
    getStatusColorRequisition,
    getStatusRequisitionTextColor
} from "../../utilz/function";

interface RequisitionData {
    _id: string;
    reqId: string;
    regionName: any;
    Item: any;
    total:string;
    status: string;
    dateRequired: string;
    urgencyLevel: string;
    sourcingOfficers: any;
}

interface UserTableProps {
    data: RequisitionData[];
    selectedStatus?: string;
    handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}


const RequisitionTable: React.FC<UserTableProps> = ({data, selectedStatus}) => {
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState<RequisitionData[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedType, setSelectedType] = useState("");


    const columns = [
        { header: "Sourcing Region", accessor: "sourceRegion" },
        { header: "Items", accessor: "Item" },
        { header: "Order Date", accessor: "orderDate" },
        { header: "status", accessor: "status" },
        { header: "Urgency", accessor: "urgency" },
        { header: "Actions", accessor: "_id" },
    ];

    const handleUserClick = (_id: string) => {
        navigate(`/dashboard/requisition/${_id}`);
    };

    useEffect(() => {
        const filtered = data?.filter((requisition) => {
            const statusMatch =
                !selectedStatus || requisition?.status === selectedStatus;

            const searchMatch =
                !searchQuery ||
                requisition?.regionName
                    ?.toLowerCase()
                    .includes(searchQuery?.toLowerCase())
            const orderMatch = !selectedType || requisition?.status === selectedType;

            return statusMatch && searchMatch && orderMatch;
        })
        setFilteredData(filtered);
    }, [data, selectedStatus, searchQuery, selectedType]);


    const combinedData = filteredData?.map((requisition) => ({
        ...requisition,
        sourceRegion: (
            <div>
                <div>{requisition?.regionName?.regionName || "N/A"}</div>
            </div>
        ),

        
        orderDate: (
            <div>
                {new Date(requisition.dateRequired).toLocaleDateString("en-GB")}
            </div>
        ),

        Item: (
            <div className="flex gap-2">
                {requisition?.Item?.length > 0 ? (
                    requisition.Item.map((item: any, index: number) => (
                        <div key={index} className="flex gap-2">{item.name || "N/A"}</div> 
                    ))
                ) : (
                    <div>No sourcing officers assigned</div>
                )}
            </div>
        ),
        status: (
            <p
                style={{
                    backgroundColor: getStatusColorDiscount(requisition?.status),
                    color: getStatusDiscountTextColor(requisition?.status),
                }}
                className="rounded-full px-2 py-1 text-sm"
            >
                {capitalizeFirstLetter(requisition.status)}
            </p>
        ),
        urgency: (
            <div
                style={{
                    backgroundColor: getStatusColorRequisition(requisition?.urgencyLevel),
                    color: getStatusRequisitionTextColor(requisition?.urgencyLevel),
                }}
                className="rounded-full px-2 py-1 text-sm text-center"
            >
                {capitalizeFirstLetter(requisition.urgencyLevel)}
            </div>
        ),
    }));

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };

    const handleRequisitionFilterChange = (selectedValue: string) => {
        setSelectedType(selectedValue);
    };
    return ( 
        <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
            <div className="md:flex justify-between px-5">
                <p className="text-[20px] font-bold">Requisitions</p>
                <div className="md:flex gap-2 items-center md:mt-0 mt-2">
                    <Input
                        name="search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="w-full"
                        placeholder="Search"
                        icon="searchIcon"
                    />

                    <FIlterSelect
                        name="status"
                        options={[
                        { value: "pendingApproval", label: "Pending Approval" },
                        { value: "active", label: "Active" },
                        ]}
                        className="mt-2 md:-mt-2 w-full md:w-[50%]"
                        icon="filterIcon"
                        onChange={handleRequisitionFilterChange}
                        value={selectedType}
                    />
                </div>
            </div>

            {combinedData?.length > 0 ? (
                <Table
                columns={columns}
                data={combinedData}
                selectedUserId={null}
                onUserClick={handleUserClick}
                />
            ) : (
                <div className="opacity-80 mt-10 font-bold text-center mx-auto">
                No Requisitions found
                </div>
            )}
        </div>
     );
}
 
export default RequisitionTable;